import type { BillingInfo } from '../../../api/billing';
import { Badge } from '../../ui/Badge/Badge';

export default function BillingAccessStatus({ status, entitlement }: {
  status: string;
  entitlement?: BillingInfo['entitlement'];
}) {
  if (entitlement?.serviceable === false) {
    const message = entitlement.reason === 'payment_failed'
      ? 'Credit access is paused because this period has no funded allowance. Review your payment status or contact support.'
      : 'Credit access is paused because no usable credit period is available. Contact support to reconcile your allowance.';
    return <div><Badge variant="warning">Access paused</Badge><p role="alert">{message}</p></div>;
  }
  if (entitlement?.state === 'internal') {
    return <Badge variant="info">Internal testing</Badge>;
  }
  return <Badge variant={status === 'active' ? 'success' : status === 'past_due' ? 'warning' : 'secondary'}>
    {status.charAt(0).toUpperCase() + status.slice(1)}
  </Badge>;
}
